var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.85 10.04C19.17 6.59 16.14 4 12.5 4C9.61 4 7.1 5.64 5.85 8.04C2.84 8.36 0.5 10.91 0.5 14C0.5 17.31 3.19 20 6.5 20H19.5C22.26 20 24.5 17.76 24.5 15C24.5 12.36 22.45 10.22 19.85 10.04ZM19.5 18H6.5C4.29 18 2.5 16.21 2.5 14C2.5 11.95 4.03 10.24 6.06 10.03L7.13 9.92L7.63 8.97C8.58 7.14 10.44 6 12.5 6C15.12 6 17.38 7.86 17.89 10.43L18.19 11.93L19.72 12.04C21.28 12.14 22.5 13.45 22.5 15C22.5 16.65 21.15 18 19.5 18ZM8.5 13H11.05V16H13.95V13H16.5L12.5 9L8.5 13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.237ff4ef.svg";
export { ForwardRef as ReactComponent };